<script setup>
import { useI18n } from "vue-i18n";
import NoticeScreen from "@/components/system/NoticeScreen.vue";

const { t } = useI18n();

const refresh = () => {
  window.location.reload();
};
</script>

<template>
  <NoticeScreen
    variant="amber"
    :status-label="t('maintenance.status')"
    :title="t('maintenance.title')"
    :message="t('maintenance.message')"
    :button-label="t('maintenance.refresh')"
    @action="refresh"
  />
</template>
